import { useContext } from 'react';
import { BeaconsContext, BeaconsContextData } from './context';

export function useBeacons(): BeaconsContextData {
    const data = useContext<BeaconsContextData | undefined>(BeaconsContext);

    if (!data) {
        throw new Error(
            "BeaconsContextData unavailable. Are you sure you're using this in a nested component of an BeaconsProvider?"
        );
    }

    return data;
}
